import { render, staticRenderFns } from "./ModalEditSettings.vue?vue&type=template&id=635ebe08&scoped=true"
import script from "./ModalEditSettings.vue?vue&type=script&lang=js"
export * from "./ModalEditSettings.vue?vue&type=script&lang=js"
import style0 from "./ModalEditSettings.vue?vue&type=style&index=0&id=635ebe08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635ebe08",
  null
  
)

export default component.exports